import { TFunction } from 'i18next'
import { passwordSchema } from 'shared/schemas/password.schema'
import { z } from 'zod'

export const getRegisterSchema = (t: TFunction<'auth', 'register'>) =>
  z
    .object({
      firstName: z
        .string()
        .min(1, { message: t('validation.first_name_required') }),
      lastName: z
        .string()
        .min(1, { message: t('validation.last_name_required') }),
      email: z.email({ message: t('validation.email_invalid') }),
      password: passwordSchema,
      confirmPassword: z
        .string()
        .min(1, { message: t('validation.confirm_password_required') }),
      terms: z.boolean().refine(Boolean, {
        message: t('validation.terms_required')
      })
    })
    .refine(data => data.password === data.confirmPassword, {
      message: t('validation.passwords_do_not_match'),
      path: ['confirmPassword']
    })
